import "./products.css";
import { EditOutlined, CheckOutlined, SettingOutlined } from "@ant-design/icons";
import { Card, Space, InputNumber, notification } from "antd";

import { useEffect, useState } from "react";
import { update_restaurant_showcase } from "../../services/products";
export default function ProductsComponent({
  callBackClickEditProduct,
  products = [],
  updateProducts,
  isLoading,
}) {
  const { Meta } = Card;
  const [editProduct, setEditProduct] = useState(null);
  const handleEditButton = (product) => (event) => {
    event.preventDefault();
    callBackClickEditProduct(product);
  };
  useEffect(() => {
    console.log("editProduct: ", editProduct);
  }, [editProduct]);

  if (!products || !Array.isArray(products) || products.length === 0) {
    return <p>Nenhum produto encontrado</p>;
  }

  return (
    <>
      <Space
        direction="horizontal"
        size="middle"
        style={{ display: "flex", margin: 10, padding: 30 }}
        className="box_product_container"
      >
        {products.map((product) => {
          return (
            <Card
              hoverable
              style={{ width: 350 }}
              cover={
                product?.picture ? (
                  <img alt="example" src={product.picture} />
                ) : (
                  ""
                )
              }
              actions={[
                <EditOutlined
                  style={{ fontSize: "23px", color: "#6A2A40" }}
                  key="edit"
                  rev={undefined}
                  onClick={handleEditButton(product)}
                />,
              ]}
              className="products_edit"
            >
              <Meta
                title={product.name}
                description={product.description}
                style={{ height: 200, overflow: "scroll", overflowY: "scroll" }}
              />
              <br></br>
              <div className="product_price_code_box">
                  <InputNumber
                    value={
                      editProduct && editProduct?.product_id === product.product_id
                        ? editProduct.price
                        : product.price
                    }
                    disabled={!editProduct || editProduct?.id !== product.id}
                    parser={(value) => parseFloat(value.replace(",", ".")) || 0}
                    onChange={(value) => {
                      setEditProduct({
                        ...product,
                        price: parseFloat(value),
                      });
                    }}
                    style={{ width: "40%" }}
                  />
                  {editProduct && editProduct.id === product.id ? (
                    <CheckOutlined
                      style={{
                        fontSize: "23px",
                        color: "#6A2A40",
                        marginLeft: 10,
                      }}
                      onClick={async () => {
                        setEditProduct(null);

                        const showcasePayload = {
                          price: editProduct.price || 0,
                        };
                        console.log("preço: ",  editProduct.price)
                        await update_restaurant_showcase({
                          showcaseId: editProduct.id,
                          requestBody: showcasePayload,
                        }).then((response) => {
                          notification.success({
                            message: "Produto atualizado com sucesso",
                          });
                          updateProducts();
                        });
                      }}
                    />
                  ) : (
                    <div style={{width: "40%", display: "flex", justifyContent:"space-between"}}>
                      <EditOutlined
                        style={{
                          fontSize: "23px",
                          color: "#6A2A40",
                          marginLeft: 10,
                        }}
                        key="edit"
                        rev={undefined}
                        onClick={() => setEditProduct(product)}
                      />
                    </div>
                  )}
                <p className="product_code_box">{product.collibri_id}</p>
              </div>
            </Card>
          );
        })}
      </Space>
    </>
  );
}
